/**
 * Site-wide canonical configuration.
 * Used by <Seo /> on every page to emit canonical + Open Graph URLs.
 */
export const SITE_URL = "https://crestlineroofing.ca";

export const canonicalFor = (path = "/") => {
  if (!path.startsWith("/")) path = `/${path}`;
  return path === "/" ? SITE_URL + "/" : SITE_URL + path.replace(/\/$/, "");
};
